// Dashboard App usage translations (en-US), loaded into dashboard.usage by ./en-US.js
module.exports = {
  label: "App usage",
  engagement: require('./usage/en-US.engagement.js'),
  platforms: require('./usage/en-US.platforms.js'),
};
